"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OidcClient = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = require("@ori/axios");
var _OidcTokenStorage = require("./storage/OidcTokenStorage");
var _CryptoUtils = require("./utils/CryptoUtils");
var _getRandomInt = require("./utils/getRandomInt");
var _singleton = require("./utils/singleton");
var _class;
/* eslint-disable no-restricted-globals -- needed */
const RANDOM_NUMBER_LOWER_BOUND = 1;
const RANDOM_NUMBER_UPPER_BOUND = 2 ** 32;
let OidcClient = exports.OidcClient = (0, _singleton.singleton)(_class = class OidcClient {
  constructor(options, oauthOptions) {
    (0, _defineProperty2.default)(this, "options", void 0);
    (0, _defineProperty2.default)(this, "oauthOptions", void 0);
    (0, _defineProperty2.default)(this, "storage", new _OidcTokenStorage.OidcTokenStorage());
    (0, _defineProperty2.default)(this, "doLogin", () => {
      const state = `S${(0, _getRandomInt.getRandomInt)(RANDOM_NUMBER_LOWER_BOUND, RANDOM_NUMBER_UPPER_BOUND)}${Date.now()}`;
      const nonce = `N${(0, _getRandomInt.getRandomInt)(RANDOM_NUMBER_LOWER_BOUND, RANDOM_NUMBER_UPPER_BOUND)}${Date.now()}`;
      const redirectUri = new URL(this.options.callbackUrl, location.origin).toString();
      const codeVerifier = _CryptoUtils.CryptoUtils.generateCodeVerifier();
      const codeChallenge = _CryptoUtils.CryptoUtils.generateCodeChallenge(codeVerifier);
      this.storage.state.set(state);
      this.storage.nonce.set(nonce);
      this.storage.redirectUri.set(redirectUri);
      this.storage.redirectUrl.set(this.options.redirectUrl);
      this.storage.codeVerifier.set(codeVerifier);
      const url = new _axios.SafeURL(`/identity/connect/authorize`, this.oauthOptions.identityUrl || location.origin);

      /* eslint-disable @typescript-eslint/naming-convention -- Query params have different style */
      url.search = new URLSearchParams({
        nonce,
        state,
        acr_values: this.oauthOptions.acrValues,
        client_id: this.oauthOptions.clientId,
        prompt: 'login',
        redirect_uri: redirectUri,
        response_type: 'code',
        scope: this.oauthOptions.scope,
        code_challenge_method: 'S256',
        code_challenge: codeChallenge
      }).toString();
      /* eslint-enable @typescript-eslint/naming-convention */

      window.location.href = url.href;
    });
    this.options = options;
    this.oauthOptions = oauthOptions;
  }
}) || _class;
